import countries from 'src/static/data/countries_uzbek.json'
 
export const getCountryUzbekName = (iso2) => countries?.[iso2];